import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/retry';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../_services/auth.service';
import { CryptoService } from '../_services/crypto.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  helper = new JwtHelperService();
  cryptoService: CryptoService = new CryptoService();

  constructor(
    private authService: AuthService,
  ) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const encryptToken = localStorage.getItem(environment.keys.accessToken);
    let savedtoken;
    if (encryptToken) {
      savedtoken = this.cryptoService.decryptText(localStorage.getItem(environment.keys.accessToken));
    }
    if (req.headers.has(environment.InterceptorSkipHeader)) {
      // bypassing jwt interceptor...

      const r = req.clone({
        headers: req.headers.delete(environment.InterceptorSkipHeader)
      });

      return next.handle(r);

    } else if (savedtoken) {
      let token = savedtoken;

      /* tslint:disable */
      const decodedToken = this.helper.decodeToken(token);
      const expirationDate = this.helper.getTokenExpirationDate(token);
      const isExpired = expirationDate === null || this.helper.isTokenExpired(token, 60);
      /* tslint:enable */

      if (!isExpired) {
        const cloned = this.setAuthHeader(req, token); // set headers and clone request
        return next.handle(cloned); // send request with new header

      } else {
        const requestUrl = req.url;
        const logoutUrl = `${environment.apiUrl}api/logout-token`;

        if (requestUrl !== logoutUrl) {  // no need to attempt to refresh token when request is logout-token
          const credsExpiry = this.readStoredValue(environment.keys.credentialsExpiry);

          if (credsExpiry === null || new Date(credsExpiry) < new Date()) {
            console.log('Credentials have expired - signing out');
            this.authService.logout();
            return next.handle(req);
          }

          const username = this.readStoredValue(environment.keys.username);
          const password = this.readStoredValue(environment.keys.password);

          if (username && password) {
            // renew token
            const creds = {
              username: username,
              password: password,
            };

            return this.authService.refreshToken(creds)
              .mergeMap((data: any) => {
                token = data.id_token; // send request with new header

                localStorage.setItem(environment.keys.accessToken, this.cryptoService.encryptText(token).toString());
                localStorage.setItem(environment.keys.username, this.cryptoService.encryptText(creds.username).toString());
                localStorage.setItem(environment.keys.password, this.cryptoService.encryptText(creds.password).toString());

                const cloned = this.setAuthHeader(req, token); // set headers and clone request
                return next.handle(cloned); // send request with new header
              });
          } else {
            // no username or password - sending request unchanged
            return next.handle(req); // send request unchanged
          }
        } else {
          console.log("skipping token re-acquisition for logout request");
          throw new Error('No valid token available to logout');
        }
      }
    } else {
      // no saved token - sending request unchanged
      return next.handle(req); // send request unchanged
    }
  }


  // Returns null when the entry is missing; decryptText() cannot take null
  private readStoredValue(key: string): string | null {
    const encrypted = localStorage.getItem(key);
    return encrypted === null ? null : this.cryptoService.decryptText(encrypted);
  }

  public setAuthHeader(req, token) {
    return req.clone({
      headers: req.headers.set('Authorization',
        'Bearer ' + token)
    });
  }
}
